export enum StaticTypes {
  //Policy Holder & Regular Driver
  GENDERS = "Genders",
  IDTYPES = "IdTypes",
  TITLES = "Titles",
  MARITAL_STATUSES = "MaritalStatuses",
  EMPLOYMENT_STATUSES = "EmploymentStatuses",
  RELATIONSHIP_TYPES = "RelationshipTypes",
  //Vehicle Details
  VEHICLE_MAKES = "VehicleMakes",
  VEHICLE_COLORS = "VehicleColors",
  VEHICLE_USE_TYPES = "VehicleUseTypes",
  VEHICLE_YEARS = "VehicleYears",
  //Parking Day & Night
  VEHICLE_PARKING_METHODS = "VehicleParkingMethods",
  VEHICLE_PARKING_LOCATIONS = "VehicleParkingLocations",
  //License
  LICENSE_TYPES = "LicenseTypes",
  LICENSE_CODES = "LicenseCodes",
  ACCIDENT_CLAIM_FREE_YEARS = "TheftClaimFreeYears",
  COVER_CLAIM_FREE_YEARS = "CoverClaimFreeYears",
}
